import styled from 'styled-components';

const WrapperStyled = styled.div`
  position: relative;
  margin-top: 100px;
`;

const CircleWrapperDecorator = styled.div`
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  z-index: 1;
`;

const ContainerStyled = styled.div`
  background: #fff;
  margin: 10px 25px;
  padding: 15px;
  mix-blend-mode: normal;
  opacity: 0.95;
  box-shadow: 1px 2px 10px rgba(0, 0, 0, 0.1);
  border-radius: 10px;
`;

export { WrapperStyled, ContainerStyled, CircleWrapperDecorator };
